const eventMap = {}
const onGlobalEvent = (event: string, cb) => {
  if (!eventMap[event]) {
    eventMap[event] = []
  }
  if (!eventMap[event].some((item) => item === cb)) {
    eventMap[event].push(cb)
  }
}
const offGlobalEvent = (event: string, cb?) => {
  if (!cb) {
    eventMap[event] = []
  } else {
    const events = eventMap[event] || []
    eventMap[event] = events.filter((item) => item !== cb)
  }
}
const emitGlobalEvent = (event: string, params: any) => {
  setTimeout(() => {
    const events = eventMap[event] || []
    events.forEach(async (cb) => {
      cb(params)
    })
  })
}
// @ts-ignore
window.onGlobalEvent = onGlobalEvent
// @ts-ignore
window.emitGlobalEvent = emitGlobalEvent
// @ts-ignore
window.offGlobalEvent = offGlobalEvent
export { onGlobalEvent, emitGlobalEvent, offGlobalEvent }
